import React, { Component } from 'react'
import { toggleIsLoading } from 'Redux/actions/ViewStateActions'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { MainWrapper, RoundedWrapper, Title } from './styles'
import { withRouter } from 'react-router'
import { withTheme } from 'styled-components'
import ButtonReg from 'components/atoms/Buttons/Button'
import DataTable from 'components/organisms/DataTable/index'
import ModalPage from 'templates/ModalPage'
import DetailCoalInventoryModal from './DetailCoalInventoryModal'
import { v4 as uuidv4 } from 'uuid'
import { getAllDirLocationsData } from 'Redux/actions/AreaActions'
import { actionFormatter4 } from 'components/molecules/TableFormatters/actionFormatterIcon'
import lo from 'lodash'
import moment from 'moment'
import { getAllProductsData } from 'Redux/actions/ProductActions'

export class StockOpnameDetailCoalInventoryForm extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isShowModal: false,
      coalStockInventoryDetailsData: {},
      isLoadingRomLocationDetail: false,
      listRomDetails: [],
    }
  }

  componentDidUpdate(prevProps) {
    const { coalProductList, listCoalLocationDetail } = this.props
    const { coalStockInventoryDetailsData } = this.state

    if (
      coalProductList !== undefined &&
      coalProductList.length &&
      !coalStockInventoryDetailsData.productCode &&
      coalStockInventoryDetailsData.dirLocationCode
    ) {
      this.onChangeGroupData(coalProductList[0], 'productCode')
    }

    if (
      listCoalLocationDetail !== undefined &&
      listCoalLocationDetail.length &&
      coalStockInventoryDetailsData.dirLocationCode
    ) {
      const found = listCoalLocationDetail.findIndex(
        (el) => el.name === coalStockInventoryDetailsData.dirLocationCode.name
      )
      if (found === -1) {
        this.onChangeGroupData(null, 'dirLocationCode')
      }
    }

    if (prevProps.listCoalLocationDetail !== listCoalLocationDetail) {
      if (
        Array.isArray(listCoalLocationDetail) &&
        listCoalLocationDetail.length === 0
      ) {
        this.onChangeGroupData(null, 'dirLocationCode')
      }
    }

    if (
      coalProductList !== undefined &&
      coalProductList.length &&
      coalStockInventoryDetailsData.productCode
    ) {
      const found = coalProductList.findIndex(
        (el) => el.name === coalStockInventoryDetailsData.productCode.name
      )
      if (found === -1) {
        this.onChangeGroupData(null, 'productCode')
      }
    }

    if (prevProps.coalProductList !== coalProductList) {
      if (Array.isArray(coalProductList) && coalProductList.length === 0) {
        this.onChangeGroupData(null, 'productCode')
      }
    }
  }

  switchModal() {
    const { isShowModal } = this.state

    this.setState({ isShowModal: !isShowModal })
  }

  addNewDetail() {
    const { form } = this.props

    if (!form['areaCode']) {
      alert('Please select area!')
      return
    }

    if (!form['period']) {
      alert('Please select period!')
      return
    }

    if (!form['surveyDate']) {
      alert('Please select survey date!')
      return
    }

    this.setState({ isLoadingRomLocationDetail: true })

    this.props
      .getAllDirLocationsData(
        form['companyCode'] || '',
        form['areaCode'].code || ''
      )
      .then(() => {
        setTimeout(() => {
          this.setState({ isLoadingRomLocationDetail: false })

          if (!this.props.listCoalLocationDetail.length) {
            alert(
              `Coal products from location "${form['areaCode'].name}" were not found`
            )
            return
          }

          const newData = {
            id: uuidv4(),
            isNew: true,
            mode: 'add',
            productCode: '',
            dirLocationCode: '',
            volume: '',
            factorScale: '',
            tonnage: '',
            remark: '',
            coalpile: '',
            startTime: '',
            endTime: '',
          }

          this.setState({ coalStockInventoryDetailsData: newData }, () => {
            this.switchModal()
          })
        }, 1000)
      })
  }

  onChangeGroupData(val, field) {
    let group = Object.assign(this.state.coalStockInventoryDetailsData)
    group[field] = val
    this.setState({ coalStockInventoryDetailsData: group })
  }

  onChangeForm = (data) => {
    this.setState({ coalStockInventoryDetailsData: data })
  }

  validateSubmit = (form) => {
    const errors = []
    const requiredFields = [
      {
        key: 'dirLocationCode',
        label: 'Coal Location',
      },
      {
        key: 'productCode',
        label: 'Coal Product',
      },
      {
        key: 'volume',
        label: 'Volume',
      },
      {
        key: 'factorScale',
        label: 'Factor Scale',
      },
      {
        key: 'tonnage',
        label: 'Tonnage',
      },
      {
        key: 'startTime',
        label: 'Start Time',
      },
      {
        key: 'endTime',
        label: 'End Time',
      },
    ]

    for (const field of requiredFields) {
      if (form[field.key] === null || form[field.key] === '') {
        errors.push(`- ${field.label} is required.`)
      }
    }

    return errors
  }

  onSubmitDetailCoalInventory = (data) => {
    const errors = this.validateSubmit(data)
    if (errors.length) {
      alert('Please address the following issues:\n' + errors.join('\n'))
      return
    }

    const {
      form: { coalStockInventoryDetails },
      onChange,
    } = this.props
    const newData = {
      ...lo.cloneDeep(data),
      mode: 'view',
    }

    const found = coalStockInventoryDetails.findIndex(
      (el) => el.dirLocationCode.name === newData.dirLocationCode.name
    )

    const foundCoalPile = coalStockInventoryDetails.findIndex(
      (el) => el.coalpile === newData.coalpile
    )

    if (newData.coalpile) {
      if (newData.isNew && data.mode !== 'edit' && found !== -1 && foundCoalPile !== -1) {
        alert('A coal location has already been selected. Please choose another.')
        return
      }
    } else {
      if (newData.isNew && data.mode !== 'edit' && found !== -1) {
        alert('A coal location has already been selected. Please choose another.')
        return
      }
    }

    switch (data.mode) {
      case 'add':
        const newList = [...coalStockInventoryDetails, newData]
        onChange('coalStockInventoryDetails', newList)
        break
      case 'edit':
        const findIndex = coalStockInventoryDetails.findIndex(
          (el) => el.id === data.id
        )
        if (findIndex !== -1) {
          const changeList = [...coalStockInventoryDetails]
          changeList[findIndex] = newData
          onChange('coalStockInventoryDetails', changeList)
        }
        break
      default:
        break
    }

    this.switchModal()
  }

  onEdit(row) {
    const { form } = this.props

    const mapEditData = {
      ...row,
      mode: 'edit',
    }
    this.setState({ coalStockInventoryDetailsData: mapEditData }, () => {
      this.switchModal()
    })

    if (mapEditData.dirLocationCode) {
      this.props.getAllDirLocationsData(
        form['companyCode'] || '',
        form['areaCode'].code || ''
      )
    }

    if (mapEditData.productCode) {
      this.fetchCoalProduct(mapEditData)
    }
  }

  onDelete(row) {
    const confirmDelete = window.confirm(
      `Are you sure to delete the detailed inventory with product name ${row.productCode.name}?`
    )
    if (!confirmDelete) return

    const {
      form: { coalStockInventoryDetails },
      onChange,
    } = this.props
    const findIndex = coalStockInventoryDetails.findIndex(
      (el) => el.id === row.id
    )
    if (findIndex !== -1) {
      const changeList = [...coalStockInventoryDetails]
      changeList.splice(findIndex, 1)
      onChange('coalStockInventoryDetails', changeList)
    }
  }

  fetchCoalProduct(data = null) {
    const { coalStockInventoryDetailsData } = this.state

    const param = data || coalStockInventoryDetailsData

    this.props.getAllProductsData(param['dirLocationCode'].sourceName || '')
  }

  render() {
    const {
      viewState: { isMobileView },
      listCoalLocationDetail,
      form,
      enableField,
    } = this.props
    const {
      isShowModal,
      coalStockInventoryDetailsData,
      isLoadingRomLocationDetail,
      coalProductList,
    } = this.state

    const config = [
      {
        dataField: 'id',
        text: 'Action',
        sort: false,
        formatter: actionFormatter4,
        formatExtraData: {
          style: { height: '34px', display: 'flex', alignItems: 'center' },
          allowEdit: enableField,
          edit: (row) => this.onEdit.bind(this, row),
          allowDel: enableField,
          del: (row, rowIndex) => this.onDelete.bind(this, row, rowIndex),
        },
        editable: false,
        isDummyField: true,
      },
      {
        dataField: 'dirLocationCode.name',
        text: 'Coal Location',
        sort: true,
        formatter: (cell, row) => {
          return row.coalpile ? `${cell}-${row.coalpile}` : cell
        }
      },
      {
        dataField: 'productCode.name',
        text: 'Coal Product',
        sort: true
      },
      {
        dataField: 'volume',
        text: 'Volume',
        sort: true,
      },
      {
        dataField: 'factorScale',
        text: 'Factor Scale',
        sort: true,
      },
      {
        dataField: 'tonnage',
        text: 'Tonnage',
        sort: true,
      },
      {
        dataField: 'startTime',
        text: 'Start Time',
        sort: true,
        formatter: (cell) => moment(cell).format('HH:mm'),
      },
      {
        dataField: 'endTime',
        text: 'End Time',
        sort: true,
        formatter: (cell) => moment(cell).format('HH:mm'),
      },
      {
        dataField: 'remark',
        text: 'Remark',
        sort: true,
      },
    ]

    return (
      <RoundedWrapper isMobile={isMobileView}>
        <MainWrapper>
          <Title>DETAIL COAL INVENTORY</Title>
          <DataTable
            leftSlot={
              <>
                {enableField && (
                  <ButtonReg
                    btnIcon={'plus-circle'}
                    btnTxt={
                      isLoadingRomLocationDetail
                        ? 'Loading...'
                        : 'Add to table list'
                    }
                    width={'150px'}
                    onClick={() => this.addNewDetail()}
                    disabled={isLoadingRomLocationDetail}
                  />
                )}
              </>
            }
            allowSearch={false}
            rightSlotAlt={true}
            defaultSize={100}
            isMobile={isMobileView}
            dataList={
              form['coalStockInventoryDetails'].length
                ? form['coalStockInventoryDetails']
                : []
            }
            columnConfig={config}
          />
          <ModalPage
            height={'650px'}
            isOpen={isShowModal}
            contentChild={
              <DetailCoalInventoryModal
                coalStockInventoryDetailsData={coalStockInventoryDetailsData}
                fnSwitch={this.switchModal.bind(this)}
                fnChange={this.onChangeGroupData.bind(this)}
                fnChangeForm={this.onChangeForm.bind(this)}
                fnOnSubmit={this.onSubmitDetailCoalInventory.bind(this)}
                romLocationDetails={listCoalLocationDetail || []}
                fnFetchCoalProduct={this.fetchCoalProduct.bind(this)}
                coalProductList={coalProductList || []}
                {...this.props}
              />
            }
          />
        </MainWrapper>
      </RoundedWrapper>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    userLogin: state.userLogin,
    viewState: state.viewState,
    listCoalLocationDetail: state.dirLocationList,
    coalProductList: state.productList,
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      toggleIsLoading,
      getAllDirLocationsData,
      getAllProductsData,
    },
    dispatch
  )

export default withRouter(
  withTheme(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(StockOpnameDetailCoalInventoryForm)
  )
)
